



















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import DatePicker from '@/components/TimelineDatePicker.vue'
import { mapGetters } from 'vuex';

import Timeline from '@/models/Timeline'
import Node from '@/models/Node'
import { SendPacket } from '@/networking/SendPacket'
import Packet, { PacketType } from '../../models/Packet'
import BInputLimited from '@/components/input_limited/BInputLimited.vue'
import Folder from '../../models/Folder';

@Component({
	components: 
	{
		DatePicker,
		BInputLimited
	},
	computed:
	{
		...mapGetters([
			'folders'
		])
	}
})
export default class CreateTimelineModal extends Vue 
{
	@Prop( Boolean ) readonly suppressNetworkMessage! : Boolean;
	@Prop({ default: -1 }) readonly defaultMapPin!: Number;
	
	initialized = false;
	timeline : Timeline = new Timeline;
	mapNodeID : Number = -1;
	private subKey = 0;
	
	get unsortedFolderList() : Folder[]
	{
		return Array.from((this as any).folders.values());
	}

	get sortedFolderList()
	{
		let result : Folder[] = [];
		if (this.unsortedFolderList.length > 0)
		{
			let unsorted = this.unsortedFolderList;
			result = unsorted.sort((a, b) => 
			{
				// numeric == natural sort, base sensitivity == case insensitive
				return a.name.trim().localeCompare(b.name.trim(), undefined, {numeric: true, sensitivity: 'base'});
			});
		}
		return result;
	}

	mounted()
	{
		this.reset();
	}

	get name()
	{
		return this.timeline.name.trim();
	}

	set name(value : string)
	{
		this.timeline.name = value;
	}

	get formValid() : Boolean 
	{
		return /*(this.projectData.type == 'none' || this.mapNodeID != -1) &&*/ this.name.length > 0;
	}
	
	get projectData()
	{
		return JSON.parse((this.$store.state as any).project.project.data);
	}

	get mapNodes()
	{
		let arr = new Map<Number, Object>();
		/*let none = new Node();
		none.name = "None";
		arr.set(-1, none);*/
		
		for (let k of this.$store.state.project.mapNodes.keys())
		{
			let v = this.$store.state.project.mapNodes.get(k);
			arr.set(k as any, v);
		}
		return arr;
	}
	
	get mapToTimeline()
	{
		return this.$store.getters.mapToTimeline;
	}

	get currentMapNode()
	{
		return this.mapNodes.get(this.mapNodeID);
	}

	currentFolderId = -1;

	changeFolder(idx : number) {
		this.currentFolderId = idx;
	}

	get currentFolder() {
		if (this.currentFolderId >= 0) {
			let res = ((this as any).folders as Map<number, Folder>).get(this.currentFolderId);
			if (res) return res;
		}
		return null;
	}

	// Methods
	show()
	{
		++this.subKey
		this.reset();
		if (!this.initialized)
		{
			this.initialized = true;
			this.$nextTick(() =>
			{
				(this.$refs as any).modal.show();
			});
			return;
		}
		(this.$refs as any).modal.show();
	}

	hide()
	{
		if (!this.initialized)
		{
			this.initialized = true;
			this.$nextTick(() =>
			{
				(this.$refs as any).modal.hide();
			});
			return;
		}
		(this.$refs as any).modal.hide();
	}

	changeMapNode(id : Number)
	{
		this.mapNodeID = id;
	}

	okClick()
	{
		if (this.projectData.type == 'none')
		{
			for (let i of this.mapNodes)
			{
				if (i[1])
				{
					this.mapNodeID = (i[1] as Node).nodeid;
				}
				break;
			}
		}

		let data = 
		{
			mapnodeid: this.mapNodeID,
			name: this.name,
			description: this.timeline.description,
			folderid: this.currentFolderId
		};

		this.$emit("submit", data);
		if (!this.suppressNetworkMessage)
		{
			SendPacket(PacketType.TimelineCreate, data);
		}
		
		this.$root.$emit('bv::hide::tooltip', 'create-timeline-tooltip');
		// TODO: Wait for timeline creation
		this.hide();

		this.$bvToast.toast(this.name + ' has been created successfully.',
		{
			title: 'Timeline Created',
			variant: 'success',
			autoHideDelay: 5000
		});
	}

	reset()
	{
		this.$set(this, 'timeline', new Timeline);
		this.mapNodeID = this.defaultMapPin;
	}
}

